import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { UserService } from '@services/user/user.service';
import { APPRoutes } from 'src/app/app.routes';

export const AdminGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (!userService.user()?.isAdmin) {
    return router.createUrlTree([APPRoutes.GROUPS]);
  }

  return true;
};
